import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PDFDocument } from "pdf-lib";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { DateRange } from "react-date-range";
import dayjs from "dayjs";
import { ChevronDown } from "lucide-react";

// import UpdatePickupAddress from "./UpdatePickupAddress";
import SelectPickupPopup from "./SelectPickupPopup";
import { FaFilter, FaBars } from "react-icons/fa";
import { HiDotsHorizontal } from "react-icons/hi";
import UpdatePackageDetails from "./UpdatePackageDetails";
import { FiMoreHorizontal, FiArrowRight, FiArrowLeft, FiCopy } from "react-icons/fi";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css
import ThreeDotLoader from "../Loader"


const Orders = (filterOrder) => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]); // Track selected orders
  // const [actionDropdownOpen, setActionDropdownOpen] = useState(false); // New dropdown state
  const [searchQuery, setSearchQuery] = useState("");
  const [refresh, setRefresh] = useState(false);
  const dropdownRefs = useRef([]);

  const toggleButtonRefs = useRef([]);

  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  const desktopActionRef = useRef(null);
  const mobileActionRef = useRef(null);

  const [showBulkShipModal, setShowBulkShipModal] = useState(false); // Local modal state
  const [selectedData, setSelectedData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [title, setTitle] = useState("");

  const [page, setPage] = useState(1); // Track current page
  const [limit, setLimit] = useState(20); // You can make this dynamic if needed
  const [totalPages, setTotalPages] = useState(1);
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [packageDetails, setPackageDetails] = useState({
    length: "",
    width: "",
    height: "",
    weight: "",
  });

  const [orderId, setOrderId] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [dateRange, setDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCustom, setShowCustom] = useState(false);
  const [pickupAddresses, setPickupAddresses] = useState([]); // Store pickup addresses
  const [selectedPickupAddress, setSelectedPickupAddress] = useState(""); // Track selected pickup address
  const [showPickupDropdown, setShowPickupDropdown] = useState(false); // Toggle dropdown visibility
  const [showPaymentTypeDropdown, setShowPaymentTypeDropdown] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const paymentRef = useRef(null);
  const dateRef = useRef(null);
  const pickupRef = useRef(null);
  const calendarRef = useRef(null);
  const paymentButtonRef = useRef(null);
  const pickupButtonRef = useRef(null);
  const dateButtonRef = useRef(null);

  //  console.log("this is filter order",filterOrder)

  // const filterOrderId=prop
  // console.log(prop)
  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [tempDateRange, setTempDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);
  const { id } = useParams();
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (paymentRef.current && !paymentRef.current.contains(event.target)) {
  //       setShowPaymentTypeDropdown(false);
  //     }
  //     if (dateRef.current && !dateRef.current.contains(event.target)) {
  //       setShowDropdown(false);
  //       setShowCustom(false);
  //     }
  //     if (pickupRef.current && !pickupRef.current.contains(event.target)) {
  //       setShowPickupDropdown(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  const dateOptions = [
    {
      label: "Today",
      range: () => ({
        startDate: dayjs().startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: dayjs().subtract(1, "day").startOf("day").toDate(),
        endDate: dayjs().subtract(1, "day").endOf("day").toDate(),
      }),
    },
    {
      label: "Last 7 Days",
      range: () => ({
        startDate: dayjs().subtract(6, "day").startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: dayjs().subtract(29, "day").startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Last Week",
      range: () => ({
        startDate: dayjs().subtract(1, "week").startOf("week").toDate(),
        endDate: dayjs().subtract(1, "week").endOf("week").toDate(),
      }),
    },
    {
      label: "Last Month",
      range: () => ({
        startDate: dayjs().subtract(1, "month").startOf("month").toDate(),
        endDate: dayjs().subtract(1, "month").endOf("month").toDate(),
      }),
    },
    {
      label: "This Year",
      range: () => ({
        startDate: dayjs().startOf("year").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Custom",
      custom: true,
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Payment dropdown outside click
      if (
        paymentRef.current &&
        !paymentRef.current.contains(event.target) &&
        paymentButtonRef.current &&
        !paymentButtonRef.current.contains(event.target)
      ) {
        setShowPaymentTypeDropdown(false);
      }

      // Pickup dropdown outside click
      if (
        pickupRef.current &&
        !pickupRef.current.contains(event.target) &&
        pickupButtonRef.current &&
        !pickupButtonRef.current.contains(event.target)
      ) {
        setShowPickupDropdown(false);
      }

      // Date dropdown and calendar outside click logic
      const insideDateButton = dateButtonRef.current?.contains(event.target);
      const insideDateDropdown = dateRef.current?.contains(event.target);
      const insideCalendar = calendarRef.current?.contains(event.target);

      if (showCustom) {
        if (!insideDateDropdown && !insideCalendar && !insideDateButton) {
          setShowDropdown(false);
          setShowCustom(false);
        }
      } else if (showDropdown) {
        if (!insideDateDropdown && !insideDateButton) {
          setShowDropdown(false);
        }
      }
      // Action dropdown (desktop)
      if (
        desktopActionRef.current &&
        !desktopActionRef.current.contains(event.target)
      ) {
        setDesktopDropdownOpen(false);
      }

      // Action dropdown (mobile)
      if (
        mobileActionRef.current &&
        !mobileActionRef.current.contains(event.target)
      ) {
        setMobileDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [
    showDropdown,
    showCustom,
    showPaymentTypeDropdown,
    showPickupDropdown,
    desktopDropdownOpen,
    mobileDropdownOpen,
  ]);

  const handleDateOptionClick = (option) => {
    if (option.custom) {
      setTempDateRange([...dateRange]);
      setShowDropdown(false);

      requestAnimationFrame(() => {
        setShowCustom(true);
      });
    } else {
      const range = option.range();
      setDateRange([
        {
          startDate: new Date(range.startDate),
          endDate: new Date(range.endDate),
          key: "selection",
        },
      ]);
      setShowDropdown(false);
      setShowCustom(false);
    }
  };

  const toggleDropdown = (index) => {
    setDropdownOpen((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    setPage(1);
  }, [refresh]);

  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setActionDropdownOpen(false); // Close dropdown if clicked outside
  //   }
  // };

  // useEffect(()=>{
  //   try {
  //     setOrders(filterOrder.orders)
  //   } catch (error) {
  //     console.error("Error fetching orders:", error);

  //   }
  // })
  // Attach event listener to detect outside clicks
  // useEffect(() => {
  //   if (actionDropdownOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [actionDropdownOpen]);

  const handleBulkDownload = async () => {
    if (selectedOrders.length === 0) {
      toast.error("No orders selected for download.");
      return;
    }

    try {
      const mergedPdf = await PDFDocument.create();

      for (let orderId of selectedOrders) {
        const response = await fetch(
          `${REACT_APP_BACKEND_URL}/printinvoice/download-invoice/${orderId}`
        );
        const blob = await response.blob();
        const existingPdfBytes = await blob.arrayBuffer();

        const existingPdf = await PDFDocument.load(existingPdfBytes);
        const copiedPages = await mergedPdf.copyPages(
          existingPdf,
          existingPdf.getPageIndices()
        );

        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }

      const mergedPdfBytes = await mergedPdf.save();
      const mergedBlob = new Blob([mergedPdfBytes], {
        type: "application/pdf",
      });
      saveAs(mergedBlob, "bulk-invoices.pdf");

      toast.success("Invoices downloaded successfully!");
    } catch (error) {
      console.error("Error downloading invoices:", error);
      toast.error("Failed to download invoices.");
    }
  };

  const handleInvoice = async (id) => {
    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/printinvoice/download-invoice/${id}`
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice-${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  const handleBulkCancel = async () => {
    let allSuccess = true;

    for (let orderId of selectedOrders) {
      try {
        const [, token] = document.cookie.split("=");
        await axios.post(
          `${REACT_APP_BACKEND_URL}/order/cancelOrdersAtNotShipped`,
          { orderId },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
      } catch (error) {
        allSuccess = false;
      }
    }

    setRefresh((prev) => !prev);

    if (allSuccess) {
      toast.success("All selected orders cancelled successfully.");
    } else {
      toast.error("Some orders could not be cancelled. Please try again.");
    }
  };

  const handleSavePackageDetails = async (details) => {
    try {
      // Extract token from cookies (handle multiple cookies safely)
      const [session, token] = document.cookie.split("=");
      if (!token) {
        console.error("Authorization token not found.");
        toast.error("Session expired. Please login again.");
        return;
      }

      // Validate selectedOrders
      if (
        !selectedOrders ||
        !Array.isArray(selectedOrders) ||
        selectedOrders.length === 0
      ) {
        console.error("No selected orders to update.");
        toast.error("Please select at least one order.");
        return;
      }

      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/order/updatePackageDetails`,
        { details, selectedOrders },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("response", response.data);
      toast.success("Package details updated successfully!");
      setRefresh(!refresh);
    } catch (err) {
      console.error("error", err);
      toast.error("Failed to update package details.");
    }
  };

  const handleBulkUpdatePickup = () => {
    setShowBulkShipModal(true);
    setSelectedData(selectedOrders); // Open the modal when clicked
  };

  const handleExportExcel = () => {
    if (selectedOrders.length === 0) {
      toast.error("No orders selected for export.");
      return;
    }

    // Filter only selected orders
    const exportData = orders
      .filter((order) => selectedOrders.includes(order._id))
      .map((order) => ({
        "Order ID": order.orderId,
        "Order Status": order.status,
        "Order Date": new Date(order.createdAt).toLocaleString(),
        "Sender Name": order.pickupAddress?.contactName,
        "Sender Email": order.pickupAddress?.email,
        "Sender Phone": order.pickupAddress?.phoneNumber,
        "Sender Address": order.pickupAddress?.address,
        "Sender City": order.pickupAddress?.city,
        "Sender State": order.pickupAddress?.state,
        "Sender Pin": order.pickupAddress?.pinCode,
        "Receiver Name": order.receiverAddress?.contactName,
        "Receiver Email": order.receiverAddress?.email,
        "Receiver Phone": order.receiverAddress?.phoneNumber,
        "Receiver Address": order.receiverAddress?.address,
        "Receiver City": order.receiverAddress?.city,
        "Receiver State": order.receiverAddress?.state,
        "Receiver Pin": order.receiverAddress?.pinCode,
        "Payment Method": order.paymentDetails?.method,
        "Payment Amount": order.paymentDetails?.amount,
        Courier: order.courierServiceName,
        "AWB Number": order.awb_number,
        // Add more fields as needed
        Products: order.productDetails
          ?.map(
            (p) =>
              `Name: ${p.name}, SKU: ${p.sku}, Price: ${p.unitPrice}`
          )
          .join(" | "),
      }));

    // Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");

    // Generate buffer and save
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "orders.xlsx");
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const [session, token] = document.cookie.split("=");

      const [pickupCity, pickupState] =
        selectedPickupAddress?.split(", ") || [];

      const params = {
        id,
        page,
        limit,
        status: "new",
        searchQuery,
        orderId,
        paymentType,
        startDate: dateRange[0].startDate?.toISOString(),
        endDate: dateRange[0].endDate?.toISOString(),
        pickupContactName: selectedPickupAddress || undefined,
      };

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/order/orders`,
        {
          params,
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      setOrders(response.data.orders);
      setTotalPages(response.data.totalPages);
      if (response.data.pickupLocations) {
        setPickupAddresses(response.data.pickupLocations);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [
    page,
    limit,
    searchQuery,
    orderId,
    paymentType,
    dateRange,
    selectedPickupAddress,
  ]);

  useEffect(() => {
    if (filterOrder.orders) {
      setOrders(filterOrder.orders); // Switch to filtered data when available
    }
  }, [filterOrder.orders]);

  const handleCancelOrder = async (orderId) => {
    try {
      // setRefresh(!refresh)
      const [session, token] = document.cookie.split("=");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/order/cancelOrdersAtNotShipped`,
        { orderId },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      toast.success(response.data.message);
      setRefresh(!refresh);
    } catch (error) {
      // console.error("Error canceling order:", error);
      toast.error("Failed to cancel order. Please try again.");
    }
  };
  const handleBulkShip = () => {
    setShowBulkShipModal(true);
    setSelectedData(selectedOrders); // Open the modal when clicked
  };

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    if (selectedOrders.length === orders.length) {
      setSelectedOrders([]); // Unselect all
    } else {
      setSelectedOrders(orders.map((order) => order._id)); // Select all
    }
    // console.log(selectedOrders)
  };

  // Handle individual row selection
  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const filteredOrders = orders.filter(
    (order) =>
      order.status === "new" && // Keep only orders with status "new"
      order.orderId.toString().includes(searchQuery) // Convert orderId to string for filtering
  );

  // const handleDateOptionClick = (option) => {
  //   if (option.custom) {
  //     setShowCustom(true); // Open the calendar
  //     setTempDateRange([...dateRange]); // Initialize tempDateRange with current dateRange
  //   } else {
  //     const range = option.range();
  //     setDateRange([
  //       {
  //         startDate: new Date(range.startDate),
  //         endDate: new Date(range.endDate),
  //         key: "selection",
  //       },
  //     ]);
  //     setShowDropdown(false);
  //     setShowCustom(false);
  //   }
  // };

  const handleClearFilters = () => {
    setSearchQuery("");
    setOrderId("");
    setPaymentType("");
    setSelectedPickupAddress("");
    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
    setPage(1);
  };
    const handleCopy = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    }
  };

  return (
    <div>
      {/* Desktop Table */}
      <div className="flex w-full sm:mb-2 flex-row justify-between items-center gap-2 sm:mt-2 rounded-lg">
        <div className="hidden md:flex md:flex-row items-center gap-2 w-3/4">
          <input
            type="text"
            placeholder="Search by Name, Email, Phone"
            className="w-full md:w-1/4 h-9 px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] placeholder:text-gray-500 focus:outline-none"
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
          />

          {/* Order ID Filter (Always Visible) */}
          <input
            type="text"
            placeholder="Search by Order ID"
            className="w-full md:w-1/5 h-9 px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] placeholder:text-gray-500 focus:outline-none"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
          />

          {/* Payment Type Dropdown */}
          <div className="relative w-full md:w-1/5" ref={paymentRef}>
            <button
              className="w-full bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
              onClick={() => {
                setShowPaymentTypeDropdown((prev) => !prev);
                setShowPickupDropdown(false);
                setShowDropdown(false);
              }}
              ref={paymentButtonRef}
            >
              {paymentType || "Payment Type"}
              <ChevronDown
                className={`w-4 h-4 ml-2 transform transition-transform ${showPaymentTypeDropdown ? "rotate-180" : ""
                  }`}
              />
            </button>

            {showPaymentTypeDropdown && (
              <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                {["Prepaid", "COD"].map((type) => (
                  <div
                    key={type}
                    className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                    onClick={() => {
                      setPaymentType(type);
                      setShowPaymentTypeDropdown(false);
                    }}
                  >
                    {type}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Pickup Address Dropdown */}
          <div className="relative w-full md:w-1/5" ref={pickupRef}>
            <button
              className="w-full bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
              onClick={() => {
                setShowPickupDropdown((prev) => !prev);
                setShowPaymentTypeDropdown(false);
                setShowDropdown(false);
              }}
              ref={pickupButtonRef}
            >
              {selectedPickupAddress || "Select Pickup Address"}
              <ChevronDown
                className={`w-4 h-4 ml-2 transform transition-transform ${showPickupDropdown ? "rotate-180" : ""
                  }`}
              />
            </button>

            {showPickupDropdown && (
              <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                {pickupAddresses.map((location, index) => (
                  <div
                    key={index}
                    className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                    onClick={() => {
                      setSelectedPickupAddress(location.contactName);
                      setShowPickupDropdown(false);
                    }}
                  >
                    <p className="text-[12px] font-[600] text-gray-500">
                      {location.contactName}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Date Range Filter */}
          <div className="relative w-full md:w-1/4" ref={dateRef}>
            <button
              className="w-full bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
              onClick={() => {
                if (showCustom) {
                  // If calendar open, close both calendar & dropdown
                  setShowDropdown(false);
                  setShowCustom(false);
                } else {
                  // Toggle dropdown normally and close others
                  setShowDropdown((prev) => !prev);
                  setShowPickupDropdown(false);
                  setShowPaymentTypeDropdown(false);
                  setShowCustom(false);
                }
              }}
              ref={dateButtonRef}
            >
              <span>
                {dateRange[0].startDate && dateRange[0].endDate
                  ? `${dayjs(dateRange[0].startDate).format(
                    "DD/MM/YYYY"
                  )} - ${dayjs(dateRange[0].endDate).format("DD/MM/YYYY")}`
                  : "Select Date"}
              </span>
              <ChevronDown
                className={`w-4 h-4 ml-2 transform transition-transform ${showDropdown ? "rotate-180" : ""
                  }`}
              />
            </button>

            {/* Dropdown Options */}
            {showDropdown && (
              <div className="absolute w-full bg-white border rounded shadow p-2 z-[50] transition-all duration-300 ease-in-out">
                <ul>
                  {dateOptions.map((option, idx) => (
                    <li
                      key={idx}
                      className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDateOptionClick(option);
                      }}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Custom Calendar */}
            {showCustom && (
              <div
                className="absolute w-full bg-white border rounded shadow p-2 z-[60] transition-all duration-600 ease-in-out"
                ref={calendarRef}
                onClick={(e) => e.stopPropagation()} // prevent calendar clicks from closing
              >
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => setTempDateRange([item.selection])}
                  ranges={tempDateRange}
                  moveRangeOnFirstSelection={false}
                  showMonthAndYearPickers={false}
                  rangeColors={["#0CBB7D"]}
                  months={1}
                  direction="horizontal"
                  showDateDisplay={false}
                  className="custom-date-range w-[240px] h-[260px] text-[12px] font-[600] text-gray-500 scale-[0.90] origin-top"
                />
                <div className="flex justify-end gap-2 mt-2">
                  <button
                    className="bg-[#0CBB7D] text-white px-3 py-1 text-xs rounded"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent button clicks from closing unexpectedly
                      setDateRange(tempDateRange);
                      setShowCustom(false);
                      setShowDropdown(false);
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* New Dropdown */}
        <div className="flex gap-2 flex-col md:flex-row w-full md:w-auto">
          {/* Mobile Top Bar */}
          <div className="flex items-center justify-between gap-2 md:hidden w-full relative">
            {/* Order ID Filter */}
            <input
              type="text"
              placeholder="Search by Order ID"
              className="w-full flex-1 h-8 px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
            />

            {/* FaFilter Button */}
            <button
              className="px-3 flex items-center justify-center text-white bg-[#0CBB7D] h-8 rounded-lg border-2 border-[#0CBB7D] transition text-[12px] font-[600]"
              onClick={() => setShowFilters((prev) => !prev)}
            >
              <FaFilter className="text-white" />
            </button>

            {/* FaBars Button */}
            <div
              className="relative block md:hidden z-[50]"
              ref={mobileActionRef}
            >
              <button
                className={`px-3 h-8 text-[12px] border-2 rounded-lg font-[600] flex items-center gap-1 ${selectedOrders.length > 0
                    ? "text-[#0CBB7D] border-[#0CBB7D]"
                    : "border-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                onClick={() =>
                  selectedOrders.length > 0 &&
                  setMobileDropdownOpen(!mobileDropdownOpen)
                }
                disabled={selectedOrders.length === 0}
              >
                <FaBars className="text-[14px]" />
              </button>

              <div
                className={`absolute right-0 top-full mt-2 w-48 bg-white shadow-lg border border-gray-200 rounded-lg z-[100] overflow-hidden transition-all duration-300 ease-in-out ${mobileDropdownOpen
                    ? "max-h-96 opacity-100 scale-100"
                    : "max-h-0 opacity-0 scale-95 pointer-events-none"
                  }`}
              >
                <ul className="py-2 font-[600] text-[10px]">
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={handleExportExcel}
                  >
                    Export
                  </li>
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={handleBulkDownload}
                  >
                    Download Invoices
                  </li>
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={() => {
                      handleBulkShip();
                      setTitle("Bulk Ship");
                    }}
                  >
                    Bulk Ship
                  </li>
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={handleBulkCancel}
                  >
                    Bulk Cancel
                  </li>
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={() => {
                      setShowPackageModal(true);
                      setMobileDropdownOpen(false);
                    }}
                  >
                    Update Package Details
                  </li>
                  <li
                    className="px-3 py-2 hover:bg-green-100 cursor-pointer"
                    onClick={() => {
                      handleBulkUpdatePickup();
                      setTitle("Bulk Update Pickup");
                    }}
                  >
                    Update Pickup Address
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Filters Section */}
          <div
            className={`transition-all w-full duration-300 ease-in-out md:hidden ${showFilters
                ? "max-h-[1000px] overflow-visible"
                : "max-h-0 overflow-hidden"
              }`}
          >
            <div className="flex flex-col w-full gap-2 overflow-visible">
              <input
                type="text"
                placeholder="Search by Name, Email, Phone"
                className="w-full h-8 px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
                onChange={(e) => setSearchQuery(e.target.value)}
                value={searchQuery}
              />

              {/* Payment Type Dropdown */}
              <div className="relative w-full z-[40]" ref={paymentRef}>
                <button
                  className="w-full bg-white h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                  onClick={() => {
                    setShowPaymentTypeDropdown((prev) => !prev);
                    setShowPickupDropdown(false);
                    setShowDropdown(false);
                  }}
                >
                  {paymentType || "Payment Type"}
                  <ChevronDown
                    className={`w-4 h-4 ml-2 transform transition-transform ${showPaymentTypeDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showPaymentTypeDropdown && (
                  <div className="absolute w-full bg-white border rounded shadow p-1 z-[40] max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                    {["Prepaid", "COD"].map((type) => (
                      <div
                        key={type}
                        className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                        onClick={() => {
                          setPaymentType(type);
                          setShowPaymentTypeDropdown(false);
                        }}
                      >
                        {type}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Pickup Address Dropdown */}
              <div className="relative w-full z-[30]" ref={pickupRef}>
                <button
                  className="w-full bg-white h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                  onClick={() => {
                    setShowPickupDropdown((prev) => !prev);
                    setShowPaymentTypeDropdown(false);
                    setShowDropdown(false);
                  }}
                >
                  {selectedPickupAddress
                    ? pickupAddresses.find(
                      (addr) => addr._id === selectedPickupAddress
                    )?.contactName || "Select Pickup Address"
                    : "Select Pickup Address"}
                  <ChevronDown
                    className={`w-4 h-4 ml-2 transform transition-transform ${showPickupDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showPickupDropdown && (
                  <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                    {pickupAddresses.map((location, index) => (
                      <div
                        key={index}
                        className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                        onClick={() => {
                          setSelectedPickupAddress(location.contactName);
                          setShowPickupDropdown(false);
                        }}
                      >
                        <p className="text-[12px] font-[600] text-gray-500">
                          {location.contactName}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Date Range Filter */}
              <div className="relative w-full z-[20]" ref={dateRef}>
                <button
                  className="w-full bg-white h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                  onClick={() => {
                    setShowDropdown((prev) => !prev);
                    setShowPickupDropdown(false);
                    setShowPaymentTypeDropdown(false);
                    setShowCustom(false);
                  }}
                >
                  <span>
                    {dateRange[0].startDate && dateRange[0].endDate
                      ? `${dayjs(dateRange[0].startDate).format(
                        "DD/MM/YYYY"
                      )} - ${dayjs(dateRange[0].endDate).format(
                        "DD/MM/YYYY"
                      )}`
                      : "Select Date"}
                  </span>
                  <ChevronDown
                    className={`w-4 h-4 ml-2 transform transition-transform ${showDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showDropdown && (
                  <div className="absolute w-full bg-white border rounded shadow p-2 z-[50] transition-all duration-300 ease-in-out">
                    <ul>
                      {dateOptions.map((option, idx) => (
                        <li
                          key={idx}
                          className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDateOptionClick(option);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Custom Calendar */}
                {showCustom && (
                  <div
                    className="absolute w-full bg-white border rounded shadow p-2 z-[60] transition-all duration-600 ease-in-out"
                    ref={calendarRef}
                    onClick={(e) => e.stopPropagation()} // prevent calendar clicks from closing
                  >
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setTempDateRange([item.selection])}
                      ranges={tempDateRange}
                      moveRangeOnFirstSelection={false}
                      showMonthAndYearPickers={false}
                      rangeColors={["#0CBB7D"]}
                      months={1}
                      direction="horizontal"
                      showDateDisplay={false}
                      className="custom-date-range w-[290px] h-[290px] text-xs"
                    />
                    <div className="flex justify-end gap-2 mt-2">
                      <button
                        className="bg-[#0CBB7D] text-white px-3 py-1 text-xs rounded"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent button clicks from closing unexpectedly
                          setDateRange(tempDateRange);
                          setShowCustom(false);
                          setShowDropdown(false);
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <button
                className="w-full h-8 mb-2 text-xs font-semibold border-2 rounded-lg text-gray-500 border-[#0CBB7D] bg-white hover:bg-gray-100 transition"
                onClick={handleClearFilters}
                type="button"
              >
                Clear Filters
              </button>
            </div>
          </div>


        </div>
        <div className="flex gap-2 flex-col md:flex-row ">
          {/* Desktop Action Button (Only visible on md+) */}
          <div
            className="relative hidden md:flex items-center gap-2"
            ref={desktopActionRef}
          >
            <button
              className="h-9 px-3 text-[12px] border-2 rounded-lg font-[600] text-gray-500 border-[#0CBB7D] bg-white hover:bg-gray-100 transition"
              onClick={handleClearFilters}
              type="button"
            >
              Clear Filters
            </button>

            <button
              className={`h-9 px-3 text-[12px] border-2 rounded-lg font-[600] flex items-center gap-1 ${selectedOrders.length === 0
                  ? "border-gray-200 text-gray-400 cursor-not-allowed"
                  : "text-[#0CBB7D] border-[#0CBB7D]"
                }`}
              onClick={() =>
                selectedOrders.length > 0 &&
                setDesktopDropdownOpen(!desktopDropdownOpen)
              }
              disabled={selectedOrders.length === 0}
            >
              <span>Actions▼</span>
            </button>

            {/* Dropdown */}
            <div
              className={`absolute mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-[100] overflow-hidden transition-all duration-300 ease-in-out ${desktopDropdownOpen
                  ? "max-h-96 opacity-100 scale-100"
                  : "max-h-0 opacity-0 scale-95 pointer-events-none"
                }`}
              style={{
                right: 0,
                top: "calc(100% + 10px)", // Adjust the distance from the button here (10px is an example)
              }}
            >
              <ul className="py-2 font-[600]">
                <li
                  className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                  onClick={handleExportExcel}
                >
                  Export
                </li>
                <li
                  className="px-3 py-2 text-gray-700 cursor-pointer text-[10px] hover:bg-green-100"
                  onClick={handleBulkDownload}
                >
                  Download Invoices
                </li>
                <li
                  className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                  onClick={() => {
                    handleBulkShip();
                    setTitle("Bulk Ship");
                  }}
                >
                  Bulk Ship
                </li>
                <li
                  className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                  onClick={handleBulkCancel}
                >
                  Bulk Cancel
                </li>
                <li
                  className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                  onClick={() => {
                    setShowPackageModal(true);
                    setDesktopDropdownOpen(false);
                  }}
                >
                  Update Package Details
                </li>
                <li
                  className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                  onClick={() => {
                    handleBulkUpdatePickup();
                    setTitle("Bulk Update Pickup");
                  }}
                >
                  Update Pickup Address
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:block overflow-x-auto overflow-y-hidden">
        <table
          className="min-w-full 
         bg-white rounded-lg shadow-md table-auto"
        >
          {/* Table Head */}
          <thead>
            <tr className="text-white border border-[#0CBB7D] bg-[#0CBB7D] text-[12px] font-[600]">
              <th className="py-2 px-3 text-center">
                <input
                  type="checkbox"
                  checked={
                    selectedOrders.length === orders.length && orders.length > 0
                  }
                  onChange={handleSelectAll}
                  className="cursor-pointer accent-[#0CBB7D] w-4"
                />
              </th>
              <th className="py-2 px-3 text-left">Order Details</th>
              <th className="py-2 px-3 text-left">Product Details</th>
              <th className="py-2 px-3 text-left">Package Details</th>
              <th className="py-2 px-3 text-left">Payment</th>
              <th className="py-2 px-3 text-left">Customer Details</th>
              <th className="py-2 px-3 text-left">Pickup Address</th>
              <th className="py-2 px-3 text-left">Status</th>
              <th className="py-2 px-3 text-center">Actions</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-6">
                  <ThreeDotLoader />
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order, index) => (
                <tr
                  key={index}
                  className="border text-gray-500 border-gray-300 hover:bg-gray-50 transition-all text-[12px] font-[400] relative"
                >
                  <td className="py-2 px-3 whitespace-nowrap text-center">
                    <input
                      type="checkbox"
                      checked={selectedOrders.includes(order._id)}
                      onChange={() => handleCheckboxChange(order._id)}
                      className="cursor-pointer accent-[#0CBB7D] w-4"
                    />
                  </td>
                  <td
                    className="py-2 px-3 whitespace-nowrap"
                    style={{ maxWidth: "200px", width: "150px" }}
                  >
                    <div className="flex items-center gap-1">
                      <Link
                        to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                        className="text-[#0CBB7D] font-medium block"
                      >
                        {order.orderId}
                      </Link>
                      <button
                        className="ml-1 text-gray-400 hover:text-[#0CBB7D] transition"
                        title="Copy Order ID"
                        onClick={() => handleCopy(order.orderId)}
                        style={{ lineHeight: 0 }}
                      >
                        <FiCopy size={14} />
                      </button>
                    </div>
                    <p className="text-gray-500 text-[10px]">
                      {new Date(order.createdAt).toLocaleDateString()}
                      <br />
                      {new Date(order.createdAt).toLocaleTimeString()}
                    </p>
                    <p className="inline-block text-white text-[8px] font-[600] bg-[#0CBB7D] py-1 px-2 rounded-lg">
                      Custom
                    </p>
                  </td>
                  <td
                    className="py-2 px-3 whitespace-normal"
                    style={{ maxWidth: "300px", width: "200px" }}
                  >
                    <p>
                      Name :{" "}
                      {order.productDetails?.map((p) => p.name).join(", ") ||
                        "-"}
                    </p>
                    <p>
                      SKU :{" "}
                      {order.productDetails?.map((p) => p.sku).join(", ") ||
                        "-"}
                    </p>
                    
                    <p>
                      Invoice Value :{" "}
                      {order.productDetails
                        ?.map((p) => p.unitPrice)
                        .join(", ") || "-"}
                    </p>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap">
                    <p>Weight: {order?.applicableWeight}</p>
                    <p>
                      L*W*H: {order.packageDetails[0]?.volumetricWeight?.length}*
                      {order.packageDetails[0]?.volumetricWeight?.width}*
                      {order.packageDetails[0]?.volumetricWeight?.height}
                    </p>
                    <p>
                      Vol. Weight:{" "}
                      {(
                        (order.packageDetails[0]?.volumetricWeight?.length *
                          order.packageDetails[0]?.volumetricWeight?.width *
                          order.packageDetails[0]?.volumetricWeight?.height) /
                        5000
                      ).toFixed(2)}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p className="font-[600]">{order.paymentDetails.amount}</p>
                    <p className="inline-block text-white text-[8px] font-[600] bg-[#0CBB7D] py-1 px-2 rounded-lg">
                      {order.paymentDetails.method}
                    </p>
                  </td>

                  <td
                    className="py-2 px-3 whitespace-nowrap"
                    style={{ maxWidth: "300px", width: "230px" }}
                  >
                    <p>{order?.receiverAddress?.contactName}</p>
                    <p className="text-gray-500">
                      {order?.receiverAddress?.email}
                    </p>
                    <div className="flex gap-2">
                      <p className="text-gray-500">
                        {order?.receiverAddress?.phoneNumber}
                      </p>
                      <p className="cursor-pointer text-[#0CBB7D] relative group">
                        <i className="fas fa-info-circle"></i>

                        {/* Tooltip (Address Popup) */}
                        <div
                          className="absolute z-50 invisible opacity-0 group-hover:visible group-hover:opacity-100 
             transition-opacity duration-200 bg-white border border-gray-200 text-[11px] 
             text-gray-700 p-3 rounded-md shadow-xl max-w-xs w-auto max-h-56 overflow-y-auto top-1/2 left-[20px] ml-2 transform -translate-y-1/2"
                          style={{
                            pointerEvents: "none", // prevent stealing focus
                          }}
                        >
                          {/* Arrow */}
                          <div
                            className="absolute -left-2 top-3 w-3 h-3 rotate-45 bg-white border-t border-l border-gray-200 shadow-sm"
                            style={{ pointerEvents: "none" }}
                          ></div>

                          {/* Address Information */}
                          <p className="font-semibold">Address:</p>
                          <p className="break-words text-[10px]">
                            {order.receiverAddress.address}
                          </p>
                          <p className="text-[10px]">
                            {order.receiverAddress.state},{" "}
                            {order.receiverAddress.city} ,
                            {order.receiverAddress.pinCode}
                          </p>
                        </div>
                      </p>
                    </div>
                  </td>
                  <td
                    className="py-2 px-3 whitespace-nowrap"
                    style={{ maxWidth: "300px", width: "250px" }}
                  >
                    <div className="flex gap-2">
                      <p className="text-gray-500 border-b border-dashed border-gray-400">
                        {order.pickupAddress.contactName}
                      </p>
                      <p className="cursor-pointer text-[#0CBB7D] relative group">
                        <i className="fas fa-info-circle"></i>

                        {/* Tooltip (Address Popup) */}
                        <div
                          className="absolute z-50 invisible opacity-0 group-hover:visible group-hover:opacity-100 
          transition-opacity duration-200 bg-white border border-gray-200 text-[11px] 
          text-gray-700 p-3 rounded-md shadow-xl overflow-auto w-[300px] top-1/2 left-[20px] ml-2 transform -translate-y-1/2"
                          style={{
                            pointerEvents: "none", // prevent stealing focus
                          }}
                        >
                          {/* Arrow */}
                          <div
                            className="absolute -left-2 top-3 w-3 h-3 rotate-45 bg-white border-t border-l border-gray-200 shadow-sm"
                            style={{ pointerEvents: "none" }}
                          ></div>

                          {/* Address Information */}
                          <p className="font-semibold text-[10px]">Address:</p>
                          <p className="break-words text-[10px]">
                            {order.pickupAddress.address}
                          </p>
                          <p className="text-[10px]">
                            {order.pickupAddress.state},{" "}
                            {order.pickupAddress.city},{" "}
                            {order.pickupAddress.pinCode}
                          </p>
                        </div>
                      </p>
                    </div>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap">
                    <span
                      className="px-2 py-1 rounded text-[10px] bg-green-100 text-green-700"
                      style={{ maxWidth: "200px", width: "100px" }}
                    >
                      {order.status}
                    </span>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <div className="flex items-center gap-2 relative justify-center">
                      {/* Ship Now Button */}
                      <button
                        className="px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] sm:text-[12px] font-[600]"
                        onClick={() =>
                          navigate(
                            `/dashboard/order/courierSelection/${order._id}`
                          )
                        }
                      >
                        Ship Now
                      </button>

                      {/* Three-dot Dropdown Button */}
                      <div
                        className="relative"
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <button
                          ref={(el) => (toggleButtonRefs.current[index] = el)} // ✅ Imp
                          className="px-2 py-2 flex items-center justify-center bg-[#0CBB7D] text-white rounded-full"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal className="text-[12px]" />
                        </button>

                        {dropdownOpen === index && (
                          <div className="absolute mt-2 right-0 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                            <ul className="py-2">
                              <li>
                                <button
                                  onClick={(e) => {
                                    console.log("Download Invoice clicked");
                                    e.stopPropagation();
                                    handleInvoice(order._id);
                                    setDropdownOpen(null);
                                  }}
                                  className="w-full text-left px-3 py-2 text-gray-700 hover:bg-green-100"
                                >
                                  Download Invoice
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation(); // ✅ Needed here too
                                    handleCancelOrder(order._id);
                                    setDropdownOpen(null);
                                  }}
                                  className="w-full text-left px-3 py-2 text-red-500 hover:bg-green-100"
                                >
                                  Cancel Order
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation(); // ✅ Also needed
                                    // Archive handler (if any)
                                    setDropdownOpen(null);
                                  }}
                                  className="w-full text-left px-3 py-2 text-gray-700 hover:bg-green-100"
                                >
                                  Archive Order
                                </button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4 text-gray-500">
                  No orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View: Display Orders as Cards */}
      <div className="md:hidden w-full space-y-4">
        <div className="p-1 bg-slate-200 rounded-md flex gap-3 items-center">
          <input
            type="checkbox"
            checked={
              selectedOrders.length === orders.length && orders.length > 0
            }
            onChange={handleSelectAll}
            className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
          />
          <span className="text-[10px] font-[600]">Select All</span>
        </div>
        <div>
          {loading ? (
            <ThreeDotLoader />
          ) : orders.length > 0 ? (
            orders.map((order, index) => (
              // <div
              //   key={index}
              //   className="bg-white border border-gray-300 rounded-lg shadow-md p-2 w-full max-w-[400px] mx-auto"
              // >
              <div
                key={index}
                className="text-black mt-3 bg-green-50 p-3 rounded-lg border-1 border-[#2d054b] shadow-md"
              >
                <div className="flex justify-between items-center ">
                  {/* Left Section: Checkbox & Order ID */}
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={selectedOrders.includes(order._id)}
                      onChange={() => handleCheckboxChange(order._id)}
                      className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                    />
                    <span className="flex">
                      <p className="font-medium mt-1 text-[10px]">Order ID: </p>

                      <div className="flex items-center gap-1 mt-1">
                      <Link
                        to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                        className="text-[#0CBB7D] text-[10px] font-medium block"
                      >
                        {order.orderId}
                      </Link>
                      <button
                        className="ml-1 text-gray-400 hover:text-[#0CBB7D] transition"
                        title="Copy Order ID"
                        onClick={() => handleCopy(order.orderId)}
                        style={{ lineHeight: 0 }}
                      >
                        <FiCopy size={10} />
                      </button>
                    </div>
                      {/* <p className="ml-3 font-medium px-2 py-1 rounded text-xs bg-blue-100 text-blue-700 rounded ">{order.status}</p>  */}
                    </span>
                  </div>
                  <div
                    className="relative inline-block"
                    ref={(el) => (dropdownRefs.current[index] = el)}
                  >
                    <button
                      className="text-gray-700 rounded-lg text-[10px]"
                      onClick={() => toggleDropdown(index)}
                    >
                      <FiMoreHorizontal size={20} className="text-black" />
                    </button>

                    {/* Backdrop for mobile + outside click */}
                    {dropdownOpen === index && (
                      <>
                        {/* Transparent backdrop to detect outside clicks */}
                        <div
                          className="fixed inset-0 z-40 md:hidden"
                          onClick={() => setDropdownOpen(null)}
                        ></div>

                        <div className="absolute right-0 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                          <ul className="text-[10px] font-[600]">
                            <li
                              onClick={() => handleInvoice(order._id)}
                              className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                            >
                              Download Invoice
                            </li>
                            <li className="px-3 py-2 text-red-500 hover:bg-gray-100 cursor-pointer">
                              <button
                                onClick={() => handleCancelOrder(order._id)}
                              >
                                Cancel Order
                              </button>
                            </li>
                            <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                              Archive Order
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <p className="text-[10px]  mb-1 text-gray-500">
                  <span>Order Created On: </span>
                  <span>
                    {new Date(order.createdAt).toLocaleString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </span>
                </p>
                <div className="flex">
                  <span className="text-[10px] font-medium text-black bg-green-200 px-2 py-1 rounded">
                    {order.category || "CUSTOM"}
                  </span>
                </div>
                <div>
                  <p className="text-gray-600 text-[10px] mt-1">
                    Applicable Weight:{" "}
                    <strong>
                      {order?.applicableWeight || 0} KG
                    </strong>
                  </p>
                </div>

                <div className="flex justify-between items-center mt-1 text-[10px]">
                  <div>
                    <p className="text-gray-700 text-[10px]">
                      {order?.pickupAddress?.pinCode || "N/N"}
                    </p>
                    <p className="text-gray-600 text-[10px]">
                      {order?.pickupAddress?.city || "N/N"},
                      {order?.pickupAddress?.state || "N/N"}
                    </p>
                  </div>
                  <span className="text-gray-500 text-[12px] mb-2 ">→</span>
                  <div className="text-right">
                    <p className="text-gray-700 text-[10px]">
                      {order?.receiverAddress?.pinCode || "N/N"}
                    </p>
                    <p className="text-gray-600 text-[10px]">
                      {order?.receiverAddress?.city || "N/N"},
                      {order?.receiverAddress?.state || "N/N"}
                    </p>
                  </div>
                </div>
                <div className="flex flex-nowrap justify-between items-center mt-3 p-3 bg-green-200 rounded-lg gap-x-1">
                  <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                    {order?.receiverAddress?.contactName || "N/N"}
                  </p>
                  <span className="text-gray-500 text-xs">|</span>
                  <p className="text-[#2d054b] text-[10px] text-center truncate max-w-[80px]">
                    {order?.paymentDetails?.method || "N/N"}
                  </p>
                  <span className="text-gray-500 text-xs">|</span>
                  <p className="font-semibold text-[10px] text-center truncate max-w-[80px]">
                    ₹{order?.paymentDetails?.amount || "N/N"}
                  </p>
                  <button
                    className="px-2 py-1 bg-[#0CBB7D] text-white rounded-lg text-[10px] flex-shrink-0"
                    onClick={() =>
                      navigate(`/dashboard/order/courierSelection/${order._id}`)
                    }
                  >
                    Ship Now
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-gray-500">
              No orders found.
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
        <div className="flex items-center gap-2">
          <label
            htmlFor="limit"
            className="text-gray-700 text-[10px] font-[600]"
          >
            Show:
          </label>
          <select
            id="limit"
            value={limit}
            onChange={(e) => {
              const selected = e.target.value;
              if (selected === "All") {
                setLimit(null); // null means no limit
                setPage(1);
              } else {
                setLimit(parseInt(selected));
                setPage(1); // reset to first page when changing limit
              }
            }}
            className="px-3 py-2 border rounded-md text-[10px] font-[600]"
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value="All">All</option>
          </select>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowLeft />
          </button>
          <span className="text-gray-700">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowRight />
          </button>
        </div>
      </div>

      {/* Modal */}
      <UpdatePackageDetails
        isOpen={showPackageModal}
        onClose={() => setShowPackageModal(false)}
        onSave={handleSavePackageDetails}
        packageDetails={packageDetails}
        setPackageDetails={setPackageDetails}
      />

      {/* Show BulkShipModal when state is true */}
      {showBulkShipModal && (
        // <UpdatePickupAddress onClose={() => setShowBulkShipModal(false)} />

        <SelectPickupPopup
          onClose={() => setShowBulkShipModal(false)}
          setSelectedData={selectedOrders}
          title={title}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      )}
    </div>
  );
};

export default Orders;
